import React from 'react'
import styled from 'styled-components'

import BackgroundImage from 'gatsby-background-image'
import { StyledFullScreenWrapper } from './SharedStyledComponents'

/**
 * In this functional component a fullscreen <BackgroundImage /> may be created
 * with art-directed images.
 * @param className   string    className(s) from styled-components.
 * @param children    nodes     Child-components.
 * @return {*}
 * @constructor
 */
const ArtDirectedFullBackground = ({halfBG, desktopBG, mediumBG, smallBG, className, children }) => {

  // Art-Direction Array
  const backgroundArtDirectionStack = [
    
    smallBG.childImageSharp.fluid,
    {
      ...mediumBG.childImageSharp.fluid,
      media: `(min-width: 491px)`,
    },
    {
      ...desktopBG.childImageSharp.fluid,
      media: `(min-width: 1601px)`,
    },
  ];

  return (
    <StyledFullScreenWrapper>
      <BackgroundImage
        Tag="section"
        className={className}
        fluid={backgroundArtDirectionStack}
        backgroundColor={`#000`}
        title=""
        id="adfullscreenbg"
        role="img"
        aria-label="Art-Directed Fullscreen Background"
        preserveStackingContext={true}
      >
        {children}
      </BackgroundImage>
    </StyledFullScreenWrapper>
  )
}




const StyledFullBackground = styled(ArtDirectedFullBackground)`
  min-height: 100vh;
  width: 100%;
  background-position: center right;

  ::before,
  ::after {
    background-attachment: fixed;
  }
  
  ${props => (props.halfBG ? 'background-image:linear-gradient(rgb(0 0 0 / 30%), rgb(0 0 0 / 50%));' : 'background-image:linear-gradient(135deg, rgb(0, 0, 0, 0.4), rgba(0, 0, 0, 0.9));')};
`

export default StyledFullBackground
